import { render, staticRenderFns } from "./finish.vue?vue&type=template&id=2a3d3909&scoped=true&"
import script from "./finish.vue?vue&type=script&setup=true&lang=js&"
export * from "./finish.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3d3909",
  null
  
)

export default component.exports